/**
 * Datas de equipamento de incêndio como texto `AAAA-MM-DD`, sem passar por `Date` com fuso:
 * `new Date('2026-10-15')` é meia-noite UTC e vira o dia 14 em Brasília.
 */

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function formatIsoDate(iso: string): string {
  const match = ISO_DATE.exec(iso);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : iso;
}

const SAO_PAULO_DAY = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Sao_Paulo',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/**
 * O dia de um instante no calendário de São Paulo, em `AAAA-MM-DD` — o mesmo em que o servidor
 * decide "data futura", seja qual for o fuso do navegador. Sem argumento, é o dia de hoje.
 */
export function saoPauloDay(instant: Date | string = new Date()): string {
  const parts = SAO_PAULO_DAY.formatToParts(new Date(instant));
  const part = (type: string): string => parts.find((item) => item.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

/** O dia de hoje em São Paulo, em `AAAA-MM-DD`. */
export function todayIso(): string {
  return saoPauloDay();
}

/** Soma meses prendendo o fim de mês: 31/01 + 1 mês = 28/02. */
export function addMonths(iso: string, months: number): string {
  const match = ISO_DATE.exec(iso);
  if (!match) return iso;

  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1 + months;
  const day = Number(match[3]);
  const lastDay = new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
  const target = new Date(Date.UTC(year, monthIndex, Math.min(day, lastDay)));

  const targetMonth = String(target.getUTCMonth() + 1).padStart(2, '0');
  const targetDay = String(target.getUTCDate()).padStart(2, '0');
  return `${target.getUTCFullYear()}-${targetMonth}-${targetDay}`;
}

/** A maior de duas datas; a ausente não conta. */
export function maxIsoDate(a: string, b: string | null | undefined): string {
  return b && b > a ? b : a;
}
